import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "panel", "returnTo"]

  connect() {
    this._handleKeydown = this._handleKeydown.bind(this)
  }

  open(event) {
    event.preventDefault()
    const returnUrl =
      event?.params?.returnUrl ||
      event?.currentTarget?.dataset?.returnTo ||
      window.location.pathname + window.location.search + window.location.hash

    if (this.hasReturnToTarget) {
      this.returnToTarget.value = returnUrl
    }

    if (this.hasContainerTarget) {
      this.containerTarget.classList.remove("hidden")
    }

    document.documentElement.classList.add("overflow-hidden")
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this._handleKeydown)
    this.panelTarget?.focus()
  }

  close(event) {
    event?.preventDefault()
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add("hidden")
    }
    document.documentElement.classList.remove("overflow-hidden")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this._handleKeydown)
  }

  backdrop(event) {
    if (event.target === this.containerTarget) {
      this.close(event)
    }
  }

  _handleKeydown(event) {
    if (event.key === "Escape") {
      this.close(event)
    }
  }
}
